var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 358.898 358.898",
    style: {
      enableBackground: "new 0 0 358.898 358.898"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_972_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_973_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1002_",
    style: {
      fill: "#682234"
    },
    d: "M290.089,141.269C290.089,59.796,247.343,0,179.449,0 C111.932,0,69.293,59.135,68.82,139.914c-2.475-0.56-5.046-0.865-7.689-0.865c-19.179,0-34.727,15.548-34.727,34.727 c0,15.758,10.499,29.056,24.88,33.302c0.335,18.89,15.742,34.102,34.711,34.102c5.798,0,11.259-1.428,16.063-3.941 c4.993,13.055,17.63,22.329,32.439,22.329c19.179,0,34.727-15.548,34.727-34.727c0-2.803-0.341-5.524-0.968-8.135 c44.084,1.686,90.604-6.62,110.677-24.92C305.325,167.728,290.089,163.207,290.089,141.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1004_",
    style: {
      fill: "#581A2B"
    },
    d: "M332.494,173.776c0-19.179-15.548-34.727-34.727-34.727 c-2.644,0-5.215,0.305-7.689,0.865C289.605,59.135,246.965,0,179.449,0c-0.032,0-0.063,0.001-0.094,0.001v216.92 c3.768,0.001,7.536-0.071,11.286-0.214c-0.627,2.611-0.968,5.332-0.968,8.135c0,19.179,15.548,34.727,34.727,34.727 c14.81,0,27.447-9.274,32.439-22.329c4.805,2.512,10.266,3.941,16.063,3.941c18.97,0,34.376-15.212,34.711-34.102 C321.995,202.832,332.494,189.534,332.494,173.776z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1005_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1006_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M207.778,180.756h-26.884h-1.256h-0.379h-1.256h-26.884 c0,74.552-36.43,67.808-36.43,67.808c0,47.368,51.162,62.392,63.313,66.806v1.537c0,0,0.533-0.11,1.446-0.359 c0.912,0.249,1.446,0.359,1.446,0.359v-1.537c12.151-4.414,63.313-19.439,63.313-66.806 C244.208,248.564,207.778,255.308,207.778,180.756z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1007_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M207.778,180.756h-26.884h-1.256h-0.189v135.792 c0.912,0.249,1.446,0.359,1.446,0.359v-1.537c12.151-4.414,63.313-19.439,63.313-66.806 C244.208,248.564,207.778,255.308,207.778,180.756z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1008_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1009_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M296.43,318.004v40.681H62.467v-40.681c0-30.431,14.377-56.963,37.605-70.913 c6.043-3.641,12.69-6.43,19.844-8.196c5.953-1.488,12.254-2.272,18.842-2.272l40.691,24.002l40.691-24.002 c6.588,0,12.889,0.784,18.842,2.272c7.154,1.766,13.802,4.554,19.844,8.196C282.053,261.041,296.43,287.573,296.43,318.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1010_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M296.429,318.005v40.68h-116.98v-98.06l36-21.23l4.69-2.77 c6.59,0,12.89,0.78,18.84,2.27c7.16,1.77,13.8,4.55,19.85,8.2C282.049,261.045,296.429,287.575,296.429,318.005z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1011_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1012_",
    style: {
      fill: "#F3DBC4"
    },
    d: "M180.354,120.925h-64.988c0.84,22.166,4.35,42.212,8.428,49.74 c9.042,16.694,29.221,38.957,55.657,38.957c26.431,0,46.607-22.262,55.652-38.957c4.077-7.528,7.588-27.574,8.429-49.74H180.354z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1013_",
    style: {
      fill: "#EDCEAE"
    },
    d: "M180.354,120.925h-1v88.694c0.032,0,0.064,0.002,0.096,0.002 c26.431,0,46.607-22.263,55.652-38.957c4.077-7.528,7.588-27.573,8.429-49.74h-63.177V120.925z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1014_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1015_",
    style: {
      fill: "#AEC7EA"
    },
    d: "M224.933,267.897h-2.955c-7.109,15.907-23.023,26.993-41.529,26.993 c-25.129,0-45.5-20.43-45.5-45.632c0-4.463,0.65-8.772,1.841-12.849c-5.881,0.139-11.524,0.899-16.882,2.241 c-7.16,1.77-13.8,4.55-19.85,8.2c-23.22,13.95-37.6,40.48-37.6,70.91v5.97h37.306l-0.306,0.5v34.667h160V324.23L224.933,267.897z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1016_",
    style: {
      fill: "#96B3D4"
    },
    d: "M296.439,317.761c0-30.43-14.38-56.96-37.6-70.91 c-6.05-3.65-12.69-6.43-19.85-8.2c-4.74-1.187-9.706-1.915-14.86-2.165c1.177,4.055,1.82,8.338,1.82,12.773 c0,25.202-20.371,45.632-45.5,45.632c-0.332,0-0.66-0.018-0.99-0.025v64.032h80v-34.667l-0.306-0.5h37.286V317.761z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.2fd7e7775cc0aa0780f52a9b5a2d9f35.svg";
export { ForwardRef as ReactComponent };